import React, { useState, useEffect } from 'react'
import './footer.scss'
import { Link } from 'react-router-dom'

const Footer = () => {
    const [location, setLocation] = useState('');
    useEffect(() => {



        const fullAddress = `1/4, Dharmarajapuram Main Road, Manapakkam, Cheenai - 600 125`

        const mapUrl = `https://www.google.com/maps?q=${encodeURIComponent(fullAddress)}&output=embed`;
        setLocation(mapUrl);


    }, []);
    return (
        <div className='footer'>
            <div className='container'>
                <div className='row'>
                    <div className='col-6 col-sm-6 col-lg-3 text-start'>
                        <h2 className='mb-4'>Links</h2>
                        <Link to="/" className='items-link'>Home</Link>
                        <Link to="/about" className='items-link'>About Us</Link>
                        <Link to="/services" className='items-link'>Services</Link>
                        <Link to="/enquiry" className='items-link'>Enquiry</Link>
                        <Link to="/contact" className='items-link'>Contact Us</Link>
                        <div className='mb-3 mb-lg-0 d-flex' style={{ display: "flex !important" }}>
                            <a target='_blank' href="https://www.facebook.com/profile.php?id=61566591563214"><i class="bi bi-facebook fs-4 me-4"></i></a>
                            <a target='_blank' href="https://x.com/Tvs_Co_Packers" ><i class="bi bi-twitter fs-4 me-4"></i></a>
                            <a target='_blank' href="https://wa.me/9600139400" ><i class="bi bi-whatsapp fs-4 me-4"></i></a>
                            {/* <a target='_blank' href="https://www.instagram.com/tvs_co_packers/" ><i class="bi bi-instagram fs-4 me-4"></i></a> */}
                            <a target='_blank' href="https://www.youtube.com/@tvscopmtransports2045" ><i class="bi bi-youtube fs-4 me-4"></i></a>
                        </div>

                    </div>
                    <div className='col-6 col-sm-6 col-lg-2 text-start'>
                        <h2 className='mb-4'>Branches</h2>
                        <p><Link to="/branches" className='items-link'>Bangalore</Link></p>
                        <p><Link to="/branches" className='items-link'>Coimbatore</Link></p>
                        <p><Link to="/branches" className='items-link'>Hyderabad</Link></p>
                        <p><Link to="/branches" className='items-link'>Mumbai</Link></p>
                    </div>
                    {/* <div className='col-12 mb-3 mb-lg-0 d-block d-sm-none'>
                        <i class="bi bi-facebook fs-4 me-4"></i>
                        <i class="bi bi-twitter fs-4 me-4"></i>
                        <i class="bi bi-whatsapp fs-4 me-4"></i>
                        <i class="bi bi-instagram fs-4 me-4"></i>
                        <i class="bi bi-youtube fs-4 me-4"></i>
                    </div> */}
                    <div className='col-12 col-sm-6 col-lg-3 text-start'>
                        <h2 className='mb-4'>Head Office</h2>
                        <p>No.1/109 Valeeswaran Koil Street, Sriram Garden, Manapakkam, Chennai - 600 125</p>
                        <a href="tel:+9600139400">
                            <i className="bi bi-telephone-outbound-fill me-2 fs-6"></i>Call Us: +91 96001 39400
                        </a>
                        <a href="mailto:tvscopmtransports@gmail.com">
                            <i className="bi bi-envelope me-2 fs-6"></i>Email: tvscopmtransports@gmail.com
                        </a>
                        {/* <p>Shop: #25,<br />
                            Kundrathur Main Road,<br />
                            Porur, (Circle),<br />
                            Chennai – 600 116.</p> */}

                    </div>
                    <div className='col-12 col-sm-6 col-lg-4 text-start' style={{display:'none'}}>
                        <iframe
                            src={`${location}`}
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            allowFullScreen
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        />
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Footer
